module.exports = __webpack_public_path__ + "img/heimweh_char_sheet_paul.af6005c3.png";